import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 30C6.727 30 0 23.27 0 15S6.727 0 15 0s15 6.727 15 15-6.727 15-15 15m0-27.001C8.382 2.999 2.999 8.382 2.999 15S8.382 27.001 15 27.001 27.001 21.618 27.001 15 21.618 2.999 15 2.999"
    }, null, -1)
  ]))]))
}
export default { render: render }